// extracted by mini-css-extract-plugin
export default {"wrapper":"PreviewCard_wrapper__jsXPL"};